export interface QueueItem {
  id: string;
  track: {
    title: string;
    source: string;
    duration_seconds: number;
    requested_by_id: number;
    url: string;
    thumbnail_url: string | null;
  };
}

export async function fetchQueue(): Promise<QueueItem[]> {
  const r = await fetch('/api/queue');
  if (!r.ok) throw new Error(`fetchQueue: HTTP ${r.status}`);
  return r.json();
}

export async function deleteQueueItem(itemId: string, token: string): Promise<void> {
  const r = await fetch(`/api/dj/queue/${encodeURIComponent(itemId)}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!r.ok) throw new Error(`deleteQueueItem: HTTP ${r.status}`);
}

export async function reorderQueue(itemIds: string[], token: string): Promise<void> {
  const r = await fetch('/api/dj/queue/reorder', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ item_ids: itemIds }),
  });
  if (!r.ok) throw new Error(`reorderQueue: HTTP ${r.status}`);
}

export async function exchangeToken(code: string): Promise<{ access_token: string; expires_in: number }> {
  const r = await fetch('/api/auth/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  if (!r.ok) throw new Error(`exchangeToken: HTTP ${r.status}`);
  return r.json();
}

export interface UserInfo {
  id: string;
  username: string;
  display_name: string;
}

export async function getUser(id: number): Promise<UserInfo> {
  const r = await fetch(`/api/users/${id}`);
  if (!r.ok) throw new Error(`getUser: HTTP ${r.status}`);
  return r.json();
}

export interface Listener {
  id: string;
  username: string;
  display_name: string;
  avatar_url: string;
}
export interface ListenersResponse {
  channel_id: string | null;
  listeners: Listener[];
}
export async function getMe(token: string): Promise<UserInfo & { avatar_url: string }> {
  const r = await fetch('/api/me', { headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error(`getMe: HTTP ${r.status}`);
  return r.json();
}

export async function djPause(token: string): Promise<void> {
  const r = await fetch('/api/dj/pause', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error(`djPause: HTTP ${r.status}`);
}
export async function djPlay(token: string): Promise<void> {
  const r = await fetch('/api/dj/play', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error(`djPlay: HTTP ${r.status}`);
}
export async function djSkip(token: string): Promise<void> {
  const r = await fetch('/api/dj/skip', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error(`djSkip: HTTP ${r.status}`);
}

export interface SyncInfo {
  voice_latency_ms: number;
  total_offset_ms: number;
}
export async function fetchSyncInfo(): Promise<SyncInfo> {
  const r = await fetch('/api/sync-info');
  if (!r.ok) throw new Error(`fetchSyncInfo: HTTP ${r.status}`);
  return r.json();
}

export async function fetchListeners(channelId?: string | null): Promise<ListenersResponse> {
  const url = channelId ? `/api/listeners?channel_id=${encodeURIComponent(channelId)}` : '/api/listeners';
  const r = await fetch(url);
  if (!r.ok) throw new Error(`fetchListeners: HTTP ${r.status}`);
  return r.json();
}

export async function queueCheck(token: string): Promise<boolean> {
  const r = await fetch('/api/dj/queue-check', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (r.status === 200) return true;
  if (r.status === 403) return false;
  throw new Error(`queueCheck: HTTP ${r.status}`);
}
